import { useSyncExternalStore } from 'react';
import { CULTURES, ANIMAUX, getSemisPourCulture } from '../constants';

/**
 * Paramètres PARTAGÉS par les 4 pages de "Eau à 3 mois" (Besoin journalier,
 * Cumul culture, Total territoire, Distribution) : comme dans l'app Shiny,
 * où une seule sidebar pilote tous les onglets, changer de page ne remet pas
 * les choix à zéro. Stockés en mémoire (module), donc réinitialisés au
 * rechargement de la page.
 */

// Le jeu de données du Shiny ne couvre que le maïs et deux élevages : on ne
// propose que cela. À élargir quand les vraies routes sortiront.
export const CULTURES_EAU3MOIS = CULTURES.filter((c) => c.famille === 'mais');
export const ANIMAUX_EAU3MOIS = ANIMAUX.filter((a) => a.id === 'VL1' || a.id === 'C1');

export const PRODUCTION_DEFAUT = {
  type: 'culture',
  id: CULTURES_EAU3MOIS[0].id,
  semis: getSemisPourCulture(CULTURES_EAU3MOIS[0].id)[0]?.value ?? null,
};

let etat = {
  production: PRODUCTION_DEFAUT,
  rcp: '8.5',       // RCP_DEFAUT du Shiny : le plan est déséquilibré en faveur du 8.5
  grandeur: null,   // null = défaut propre à chaque page
  coupure: null,    // null = première coupure disponible
  // Total territoire : les résidents écrasent les autres postes, donc masqués
  // par défaut (comme le Shiny).
  masquerResidents: true,
};
const abonnes = new Set();

function modifier(patch) {
  etat = { ...etat, ...patch };
  abonnes.forEach((f) => f());
}

export function useParametresEau3Mois() {
  const courant = useSyncExternalStore(
    (f) => { abonnes.add(f); return () => abonnes.delete(f); },
    () => etat
  );
  return { ...courant, modifier };
}

/** Paramètres tels que les attend l'API (cf. mockEau3Mois.js). */
export function versParametresApi({ production, rcp, grandeur, coupure }, extra = {}) {
  return {
    type: production.type,
    idProduction: production.id,
    semis: production.semis,
    alimentation: production.alimentation,
    abreuvement: production.abreuvement,
    rcp,
    grandeur,
    coupure,
    ...extra,
  };
}
